import { RECORDING_MIME_CANDIDATES } from "../config/constants.ts";

export function selectRecordingMime(
  isTypeSupported: (mime: string) => boolean = (mime) => {
    if (typeof MediaRecorder === "undefined") return false;
    try {
      return MediaRecorder.isTypeSupported(mime);
    } catch {
      return false;
    }
  },
): string | null {
  for (const candidate of RECORDING_MIME_CANDIDATES) {
    if (isTypeSupported(candidate)) return candidate;
  }
  return null;
}

export function recordingExtension(mime: string | null): "webm" | "mp4" {
  return mime?.includes("mp4") ? "mp4" : "webm";
}

export function timestampedFilename(now = new Date(), mime: string | null = "video/webm"): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}`;
  return `gestureverse-demo-${stamp}.${recordingExtension(mime)}`;
}
